<template>
  <div class="main-content-container">
    <template v-if="hasCreateBar">
      <actions-bar>
        <div class="level">
          <div class="level-left"></div>
          <div class="level-right">
            <div class="level-item">
              <dropdown
                v-if="hasPermission([10002, 20002, 30002])"
                has-backdrop
              >
                <template v-slot:trigger>
                  <button class="button is-wide is-secondary">
                    Create New
                  </button>
                </template>
                <template v-slot:content>
                  <button
                    v-if="hasPermission(20002) && hasRole('organization admin')"
                    class="button is-wide is-create-new"
                    @click="
                      createDivision = true;
                      isWorkgroup = false;
                    "
                  >
                    Division
                  </button>
                  <button
                    v-if="hasPermission(20002) && hasRole('division admin')"
                    class="button is-wide is-create-new"
                    @click="
                      createDivision = true;
                      isWorkgroup = true;
                    "
                  >
                    Workgroup
                  </button>
                  <button
                    v-if="hasPermission(30002)"
                    class="button is-wide is-create-new"
                    @click="createProjectDialog = true"
                  >
                    Project
                  </button>
                  <button
                    v-if="hasPermission(10002)"
                    class="button is-wide is-create-new"
                    @click="createUser = true"
                  >
                    User
                  </button>
                </template>
              </dropdown>
            </div>
          </div>
        </div>
      </actions-bar>

      <app-modal v-model="createUser" title="Create User" @close="user = {}">
        <validation-observer ref="formuser">
          <user-form v-model="user"></user-form>
        </validation-observer>
        <div class="create-dialog-actions">
          <div class="button is-primary" @click="submitUser">Create</div>
        </div>
      </app-modal>

      <app-modal
        v-model="createProjectDialog"
        title="Create Project"
        @close="project = {}"
      >
        <validation-observer ref="formproject">
          <project-form v-model="project" is-create></project-form>
        </validation-observer>
        <div class="create-dialog-actions">
          <div class="button is-primary" @click="submitProject">Create</div>
        </div>
      </app-modal>

      <app-modal
        v-model="createDivision"
        :title="isWorkgroup ? 'Create workgroup' : 'Create division'"
        @close="group = {}"
      >
        <validation-observer ref="formgroup">
          <group-form v-model="group" :is-workgroup="isWorkgroup"></group-form>
        </validation-observer>
        <div class="create-dialog-actions">
          <div class="button is-primary" @click="submitDivision">Create</div>
        </div>
      </app-modal>
    </template>
    <transition :name="$store.state.transition">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash';
import ActionsBar from '@/components/ActionsBar.vue';
import AppModal from '@/components/AppModal.vue';
import Dropdown from '@/components/Dropdown';
import UserForm from '@/components/forms/UserForm.vue';
import ProjectForm from '@/components/forms/ProjectForm.vue';
import GroupForm from '@/components/forms/GroupForm.vue';
import { ValidationObserver } from 'vee-validate';

export default {
  name: 'AppHome',
  components: {
    ActionsBar,
    AppModal,
    Dropdown,
    UserForm,
    ProjectForm,
    GroupForm,
    ValidationObserver
  },
  data() {
    return {
      createUser: false,
      createProjectDialog: false,
      createDivision: false,
      user: {},
      project: {},
      group: {},
      isWorkgroup: false
    };
  },
  computed: {
    hasCreateBar() {
      return ['users', 'projects', 'divisions'].includes(this.$route.name);
    }
  },
  methods: {
    submitUser() {
      this.$refs.formuser.validate().then(success => {
        if (!success) {
          this.showErrorMessage('Please check the errors');
          return;
        } else {
          this.axiosRequest(
            'post',
            `Users`,
            _.pick(this.user, ['firstName', 'lastName', 'email', 'password'])
          )
            .then(response => {
              this.$store.commit('users/add', response.data);
              const promises = this.user.roles.map(el =>
                this.axiosRequest(
                  'post',
                  `Users/${response.data.userID}/Roles`,
                  {
                    userID: response.data.userID,
                    roleID: el.roleID,
                    groupID: el.groupID,
                    applyDefaultPermissions: true
                  }
                )
              );
              return Promise.all(promises);
            })
            .then(response => {
              this.createUser = false;
              this.user = {};
              this.showSuccessMessage('New user created.');
            })
            .catch(error => {
              this.showErrorMessage(error);
            });
        }
      });
    },
    submitProject() {
      this.$refs.formproject.validate().then(success => {
        if (!success) {
          this.showErrorMessage('Please check the errors');
          return;
        } else {
          this.axiosRequest('post', 'Projects', {
            ...this.project
          })
            .then(response => {
              this.$store.commit('projects/add', response.data);
              this.createProjectDialog = false;
              this.project = {};
              this.showSuccessMessage('New project created.');
            })
            .catch(error => {
              this.showErrorMessage(error);
            })
            .finally(this.releaseUI);
        }
      });
    },
    submitDivision() {
      this.$refs.formgroup.validate().then(success => {
        if (!success) {
          this.showErrorMessage('Please check the errors');
          return;
        } else {
          this.axiosRequest('post', 'Groups', {
            ...this.group,
            organizationID: this.$store.getters.userOrganization
          })
            .then(response => {
              //console.log(response.data);
              this.$store.commit('groups/add', response.data);
              this.createDivision = false;
              this.group = {};

              this.showSuccessMessage('New group added.');
            })
            .catch(error => {
              this.showErrorMessage(error);
            })
            .finally(this.releaseUI);
        }
      });
    }
  }
};
</script>

<style lang="scss">
// .page-content {
//   padding-top: 90px;
// }
.sub-navbar {
  // position: fixed;
  // top: $navbar-height;
  // left: 0;
  // right: 0;
  // height: 90px;
  // z-index: 2;
  nav {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .navbar-item {
    margin: 2.5rem 0 1.5rem;
    position: relative;
    background-color: transparent !important;
    font-size: 1.9rem;
    color: $white !important;
    opacity: 0.5;
    font-weight: $weight-book;
    // transition: opacity $regular-timing $regular-anim;

    &:not(:last-child) {
      margin-right: 10rem;
    }

    &::after {
      display: block;
      content: '';
      position: absolute;
      bottom: -1.5rem;
      right: 0;
      left: 0;
      border-bottom: solid 3px transparent;
      // transition: border-color $regular-timing $regular-anim;
    }

    &:hover,
    &.router-link-active {
      opacity: 1;
      font-weight: $weight-regular;
      &::after {
        border-bottom-color: $primary;
      }
    }
  }
}
.create-dialog-actions {
  text-align: center;
  margin-top: 6rem;
}
</style>
